<style lang="scss">
  @import '../resources/scss/nav_link.scss';
</style>

<script lang="ts">
  import MediaQuery from './MediaQuery.svelte'
  import { ScreenSizes } from '../config/screen_sizes'
  import { link } from 'svelte-navigator'
  import { Slugs } from '../config/slugs'
  export let ref = '#'
  export let name = '#'
  export let isIcon = false
  export let color = ''
  export let slug = ''
  export let main = false
  export let submenusShown: boolean | undefined = undefined
  export let active = false
  export let mobile = false
  export let external: boolean | undefined = undefined
  export let notDropdown: boolean | undefined = undefined
  export let submenuLink: boolean | undefined = undefined
  let assetsPath = String(process.env.CMS_ASSETS_URL)

  function closeMobile() {
    if (notDropdown) {
      const toggleButton = document.querySelector('.navbar-toggler') as HTMLButtonElement
      toggleButton.click()
    }
  }
</script>

<MediaQuery query="(max-width: {ScreenSizes.LG_MIN_WIDTH}px)" let:matches>
  {#if isIcon}
    <a class="nav-link" class:logo-active={active} href={ref}
      ><img src={name} alt="menu icon" /></a
    >
  {:else if external}
    <a
      class="nav-link mb-0"
      class:text-uppercase={!main && !mobile}
      class:special-bg={color.length}
      class:caption1={main}
      class:fs-5={mobile}
      class:ff-bold={mobile}
      class:h6={!mobile}
      href={ref}
      target="_blank"
      rel="noopener"
      >{name}
    </a>
  {:else}
    <a
      class="nav-link mb-0"
      class:text-uppercase={!main && !mobile}
      class:active
      class:special-bg={color.length}
      class:caption1={main}
      class:fs-5={mobile}
      class:ff-bold={mobile}
      class:h6={!mobile}
      class:dropdown-link={notDropdown && submenuLink}
      class:py-3={notDropdown && submenuLink}
      on:click={closeMobile}
      href={ref}
      use:link
      >{name}
      {#if matches && typeof submenusShown === 'boolean' && slug == Slugs.Projects}
        <span class="d-lg-none float-end me-3 pe-1"
          ><img
            class="chevron"
            class:open={submenusShown}
            src="{assetsPath}94c8b320-79b8-43d9-8965-078fadc6bf9c"
            alt="arrow"
          /></span
        >
      {/if}
    </a>
  {/if}
</MediaQuery>
